<template>
  <div class="row justify-content-between" v-if="checkBookingPayments != null && booking != null">
    <div class="col-lg-6">
      <div class="card-item p-3">
        <div class="contact-form-action">
          <div class="input-box">
            <label class="label-text">Fiyat :</label>
            <span class="text">{{booking.price | toCurrency}}</span>
          </div>
          <div class="input-box">
            <label class="label-text">Vergi :</label>
            <span class="text">{{booking.taxPrice | toCurrency}}</span>
          </div>
          <div class="input-box">
            <label class="label-text">Ek Hizmetler :</label>
            <span class="text">{{booking.additionalServicePrice | toCurrency}}</span>
          </div>
          <div class="input-box" v-if="booking.bookingStatus !== 'CANCELLED'">
            <label class="label-text">indirim :</label>
            <span class="text">{{booking.discountPrice | toCurrency}}</span>
            <a href="#" @click="showCreateDiscountModal()">İndirim Güncelle</a>
          </div>
          <div class="input-box" v-if="booking.bookingStatus !== 'CANCELLED'">
            <label class="label-text">Ceza :</label>
            <span class="text">{{booking.penaltyPrice | toCurrency}}</span>
            <a href="#" @click="showCreatePenaltyModal()">Ceza Güncelle</a>
          </div>
          <div class="input-box">
            <label class="label-text">Toplam Fiyat :</label>
            <span class="text">{{booking.totalPrice | toCurrency}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card-item p-3">
        <div class="input-box">
          <label class="label-text">Kredi Kartı Ödenen :</label>
          <span class="text">{{checkBookingPayments.cardPaymentBalance | toCurrency }}</span>
        </div>
        <div class="contact-form-action">
          <div class="input-box">
            <label class="label-text">Cari Ödenen :</label>
            <span class="text">{{checkBookingPayments.creditPaymentBalance | toCurrency}}</span>
          </div>
          <div class="input-box">
            <label class="label-text">Ödenen :</label>
            <span class="text">{{checkBookingPayments.paidAmount | toCurrency}}</span>
          </div>
          <div class="input-box">
            <label class="label-text">Kalan ödeme :</label>
            <span class="text">{{checkBookingPayments.requiredAmount | toCurrency}}</span>
          </div>
          <div class="input-box">
            <label class="label-text">Proformalar :</label>
            <span v-if="booking.proformas == null || booking.proformas.length > 0" style="margin-left: 5px !important;" class="clickable-text" v-for="proforma in booking.proformas" @click="downloadProforma(proforma)">{{proforma}}</span>
            <span v-else style="margin-left: 5px !important;" class="text" v-for="proforma in booking.proformas" @click="downloadProforma(proforma)">{{proforma}}</span>
          </div>
          <div class="input-box">
            <label class="label-text">Proforma Kilidi :</label>
            <span v-if="booking.proformaLocked"> Kilitli </span>
            <span v-if="!booking.proformaLocked"> Açık </span>
            <span v-if="booking.proformaLocked" class="clickable-text" @click="toggleProformaLock"> ( Kilidi Aç )</span>
            <span v-if="!booking.proformaLocked" class="clickable-text" @click="toggleProformaLock"> ( Kilitle )</span>

          </div>
          <div class="input-box">
            <label class="label-text">İade edilecek tutar :</label>
            <span class="text">{{checkBookingPayments.refundAmount | toCurrency}}</span>
          </div>
          <button v-if="(booking.bookingStatus ==='PENDING' || checkBookingPayments.requiredAmount>0)" @click="remotePaymentStart" class="theme-btn theme-btn-small theme-btn-transparent">
            <i class="la la-plus mr-1"></i>
            Uzaktan Ödeme
          </button>
          <button v-if="checkBookingPayments.refundAmount>0" @click="startCreateRefund" class="theme-btn">
            <i class="la la-plus mr-1"></i>
            Yeni İade Yarat
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookingPaymentInformation",
  computed:{
    booking:{
      get(){
        return this.$store.getters.getBooking
      }
    },
    checkBookingPayments:{
      get(){
        return this.$store.getters.getCheckBookingPayments
      }
    },
    projectName:{
      get() {
        return this.$store.getters.getProjectName;
      }
    }
  },
  methods:{
    toggleProformaLock : function () {
      this.$store.dispatch("toggleProformaLock", {id: this.booking.id, lock: !this.booking.proformaLocked}).then(()=>{
        this.booking.proformaLocked = !this.booking.proformaLocked;
      });
    },
    downloadProforma : function (id){
      this.$store.dispatch("downloadProformaByProformaInvoiceId", {id: id});
    },
    remotePaymentStart(){
      $("#remotePaymentStart").modal("show");
    },
    startCreateRefund(){
      $("#createRefundModal").modal("show");
    },
    showCreateDiscountModal(){
      $("#createDiscountModal").modal("show");
    },
    showCreatePenaltyModal(){
      $("#createPenaltyModal").modal("show");
    }
  }

}
</script>

<style scoped>
.clickable-text {
  color: blue !important;
  text-decoration: underline !important;
  cursor: pointer !important;
}

</style>